import cls from 'classnames';
import Item from './Item';
import styles from './index.module.scss';
export default (props: Record<string, any>) => {
  const { dataSource = [] } = props;
  return (
    <div className={cls(styles['production-container'])}>
      {dataSource.map((item: any) => (
        <Item data={item} key={item.id}/>
      ))}
    </div>
  );
};
